import { ADMIN_BFF_URL } from "environment";
import { axiosInstance } from "./axios";

interface IDateRange {
  start_date: string;
  end_date: string;
}

export async function budgetsByDate({ start_date, end_date }: IDateRange) {
  const response = await axiosInstance.get(
    ADMIN_BFF_URL + "/v2/dashboard/budgets-by-date-range/",
    {
      params: {
        start_date,
        end_date,
      },
    }
  );

  return response.data;
}

export async function totalBudgetByDate({
  start_date,
  end_date,
  status,
}: IDateRange & { status?: number }) {
  const response = await axiosInstance.get(
    ADMIN_BFF_URL + "/v2/dashboard/total-budget-by-date-range/",
    {
      params: {
        start_date,
        end_date,
        status,
      },
    }
  );

  return response.data;
}

export async function totalTouchedLivesByDate({
  start_date,
  end_date,
}: IDateRange) {
  const response = await axiosInstance.get(
    ADMIN_BFF_URL + "/v2/dashboard/total-touched-lives-by-date-range/",
    {
      params: {
        start_date,
        end_date,
      },
    }
  );

  return response.data;
}

export async function topAggregateSalesByDate({
  start_date,
  end_date,
  limit = 10,
  field,
}: IDateRange & { field: string; limit?: number }) {
  const response = await axiosInstance.get(
    ADMIN_BFF_URL + "/v2/dashboard/top-aggregate-sales-by-date-range/",
    {
      params: {
        start_date,
        end_date,
        limit,
        field,
      },
    }
  );

  return response.data;
}
